
import { Deals } from "@/components/Deals";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { LocalFavoritesContainer } from "@/components/local-favorites/LocalFavoritesContainer";
import { useNavigate } from "react-router-dom";

const DealsPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  const handleShowAllVacations = () => {
    navigate('/alle-vakanties');
  };

  const handleShowDeals = () => {
    navigate('/deals');
  };

  const handleShowLuxury = () => {
    navigate('/luxe');
  };

  const handleShowRondreizen = () => {
    navigate('/rondreizen');
  };

  const handleShowThema = () => {
    navigate('/thema');
  };

  const handleShowFavoritesComparison = () => {
    navigate('/favorieten-vergelijken');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex flex-col">
      <Header 
        onShowAllVacations={handleShowAllVacations}
        onShowDeals={handleShowDeals}
        onShowLuxury={handleShowLuxury}
        onShowRondreizen={handleShowRondreizen}
        onShowThema={handleShowThema}
        onShowFavoritesComparison={handleShowFavoritesComparison}
        onGoHome={handleGoHome}
        currentView="deals"
      />
      
      <main className="flex-1">
        <div className="container mx-auto px-4 py-8">
          <Deals onBack={handleBack} />
        </div>
      </main>
      
      <LocalFavoritesContainer />
      <Footer />
    </div>
  );
};

export default DealsPage;
